var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    width: "1em",
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2507 4.66797C12.2507 3.70147 11.4672 2.91797 10.5007 2.91797H5.83398C4.86749 2.91797 4.08398 3.70147 4.08398 4.66797V11.668C4.08398 12.6345 4.86749 13.418 5.83398 13.418H10.5007C11.4672 13.418 12.2507 12.6345 12.2507 11.668V4.66797ZM11.084 4.66797C11.084 4.34581 10.8228 4.08464 10.5007 4.08464H5.83398C5.51182 4.08464 5.25065 4.34581 5.25065 4.66797V11.668C5.25065 11.9901 5.51182 12.2513 5.83398 12.2513H10.5007C10.8228 12.2513 11.084 11.9901 11.084 11.668V4.66797Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.7487H9.33333C9.65551 1.7487 9.91667 1.48753 9.91667 1.16536C9.91667 0.843201 9.65551 0.582031 9.33333 0.582031H3.5C2.5335 0.582031 1.75 1.36554 1.75 2.33203V10.4987C1.75 10.8209 2.01117 11.082 2.33333 11.082C2.6555 11.082 2.91667 10.8209 2.91667 10.4987V2.33203C2.91667 2.00987 3.17784 1.7487 3.5 1.7487Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.c5629f4867b324c023dcc6dcd91c91ee.svg";
export { ForwardRef as ReactComponent };